module.exports = __webpack_public_path__ + "img/carrousel-mov-digi-6.d31747d9.png";